// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3tgb1","alert":"SettungsInbox_alert__hHg9J"};